// css
import '@st-operations/uikit/css/core.styl'
import '../css/App.scss'

// dependencies
import React from 'react'
import classnames from 'classnames'
import { BrowserRouter, Route, Redirect } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import Fader from 'react-fader'
import TransitionSwitch from 'react-router-transition-switch'

// components
import RecoverPasswordPage from './pages/recover-password-page'
import ContentContainer from '_components/content-container/index.jsx'
import UrlSimilaritySeed from '_components/url-similarity-seed/index.jsx'

// pages
import ABCustomAudiences from './pages/ab-custom-audiences/index.jsx'
import AcceptInvitationPageComponent from './pages/accept-invitation/index.jsx'
import APADataSources from './pages/apa-data-sources'
import ApiPage from './pages/ApiPage.jsx'
import AppNexusAudiences from './pages/appnexus-audiences/index.jsx'
import AppNexusAudience from './pages/appnexus-audiences/appnexus-audience/index.jsx'
// import AISimulatedCustomer from './pages/ai-simulated-customer'
// import AISimulatedCustomerList from './pages/ai-simulated-customer-list'
import AudienceCreator from './pages/audience-creator/index.jsx'
import BulkEditAudiences from './pages/bulk-edit-audiences/index.jsx'
import MoveAudiencesToPdp from './pages/move-audiences-to-pdp/index.jsx'
import AudienceInsights from './pages/audience-insights/index.jsx'
import AudienceInsightsReportPage from './pages/audience/report/index.jsx'
import TaxonomyAudiencePage from './pages/audience/taxonomy/index.jsx'
import BrandedAudiences from './pages/branded-audiences/index.jsx'
import Changelogs from './pages/changelogs'
import Companies from './pages/Companies.jsx'
import Company from './pages/Company.jsx'
import ContentRule from './pages/content-rules/content-rule/index.jsx'
import ContentRuleLogs from './pages/content-rule-logs/index.jsx'
import ContentRules from './pages/content-rules/index.jsx'
import CustomAudiences from './pages/audience-creator-list/index.jsx'
import DaaSClients from './pages/DaaSClients.jsx'
import DataSourceAPAPage from './pages/apa-data-sources/data-source'
import EventFeeds from './pages/event-feeds/index.jsx'
import EventFeedsList from './pages/event-feeds/list-view/index.jsx'
import { EventFeedsContextProvider } from './pages/event-feeds/context/index.jsx'
import DataFeed from './pages/DataFeed.jsx'
import DataFeeds from './pages/DataFeeds.jsx'
import DataSource from './pages/DataSource.jsx'
import DataSources from './pages/DataSources.jsx'
import Destination from './pages/destination/index.jsx'
import Destinations from './pages/Destinations.jsx'
import DataExplorerSyntheticUsers from './pages/SyntheticUsers.jsx'
import Downloads from './pages/Downloads'
import PdpAudienceNotificationRule from './pages/pdp-audience-notification-rules/rule/index.jsx'
import PdpAudienceNotificationRules from './pages/pdp-audience-notification-rules/index.jsx'
import PdpLiveRampReport from './pages/pdp-liveramp-report/index.jsx'
import PdpOmmBillableReport from './pages/pdp-omm-billable-report/index.jsx'
import ForgotPasswordPage from './pages/forgot-password/index.jsx'
import Dashboard from './pages/dashboard/index.jsx'
import ImportTopics from './pages/ImportTopics.jsx'
import IndividualRecords from './pages/individual-records/index.jsx'
import Integrations from './pages/Integrations.jsx'
import Login from './pages/Login.jsx'
import Link from './pages/Link.jsx'
import Links from './pages/Links.jsx'
import LiveRamp from './pages/LiveRamp.jsx'
import LogFile from './pages/LogFile.jsx'
import LogFiles from './pages/LogFiles.jsx'
import MappingID from './pages/MappingID.jsx'
import MappingIDs from './pages/MappingIDs.jsx'
import PageNotFound from './pages/page-not-found/index.jsx'
import PartnerBrandedAudiences from './pages/partner-branded-audiences/index.jsx'
import People from './pages/People.jsx'
import PeopleModel from './pages/people-model/PeopleModel'
import Person from './pages/Person.jsx'
import PixelAudience from './pages/PixelAudience.jsx'
import PixelAudiences from './pages/pixel-audiences/index.jsx'
import PixelClasses from './pages/PixelClasses.jsx'
import Pixels from './pages/Pixels.jsx'
import PredactivAdmin from './pages/predactiv-admin/PredactivAdmin'
import Region from './pages/Region.jsx'
import Regions from './pages/Regions.jsx'
import SalesforceIntegrationPartner from './pages/salesforce-integration-partner'
import SalesforceIntegrationPartners from './pages/SalesforceIntegrationPartners.jsx'
import Search from './pages/Search.jsx'
import SegmentConfigs from './pages/segment-configs'
import SettingsPage from './pages/settings/index.jsx'
import SegmentIdsPage from './pages/segment-ids/index.jsx'
import SegmentIdPage from './pages/segment-ids/segment-id/index.jsx'
import TaxonomiesPage from './pages/taxonomies/index'
import TaxonomyAudiences from './pages/taxonomies/audiences'
import TaxonomyApiIntegrations from './pages/taxonomies/taxonomy/api-integrations'
import TaxonomyApiIntegrationPush from './pages/taxonomies/taxonomy/api-integrations/push'
import AllTaxonomyApiIntegrations from './pages/taxonomy-api-integrations'
import Taxonomy from './pages/taxonomies/taxonomy/index.jsx'
import TTDAudiences from './pages/ttd-audiences/index.jsx'
import TTDAudience from './pages/ttd-audiences/ttd-audience/index.jsx'
import TTDHealthAudiences from './pages/ttd-health-audiences/index.jsx'
import TTDHealthAudience from './pages/ttd-health-audiences/ttd-health-audience/index.jsx'
import UserAttributeSync from './pages/UserAttributeSync.jsx'
import UserAttributeSyncs from './pages/UserAttributeSyncs.jsx'
import WhiteLabelAudiences from './pages/white-label-audiences/index.jsx'
import ErrorPage from './pages/ErrorPage.jsx'
// TODO: Delete after creating the new Partner Branded Audiences
import Old from './pages/PartnerBrandedAudiences-old.jsx'

// DEMO SLIDES
import SlidesDemo from './pages/slides-demo/SlidesDemo.jsx'

// libraries
import toast from '@st-operations/uikit/lib/toast.js'

// services
import API from './lib/API.js'
import Storage from '@st-operations/uikit/Storage.js'
import User from './lib/User.js'
import getRefreshTokenInterceptor from './lib/getRefreshTokenInterceptor'
import i18n from '@st-operations/uikit/i18n.js'
import decode from 'jwt-decode'
import Cookies from '_lib/cookies.js'

//context providers
import { NavigationProvider } from './contexts/NavigationContext.jsx'
import { PDPEnvironmentProvider } from './contexts/PDPEnvContext'

import '../App.css'
import DataMonitoring from './pages/data-monitoring'
import CustomTaxonomies from './pages/custom-taxonomies'
import CustomTaxonomy from './pages/custom-taxonomy'
import UrlSimilaritySeeds from './pages/url-similarity-seeds'
import Sidebar2 from './components/sidebar2/index.jsx'

import MediaMeasurementCampaigns from './pages/media-measurement-campaigns'
import MediaMeasurementCampaignsLogs from './pages/media-measurement-campaigns-logs'
import MediaMeasurementCampaign from './pages/media-measurement-campaign'
import ContentRuleChangeRequests from './pages/content-rule-change-requests'
import ContentRuleChangeRequest from './pages/content-rule-change-request'
import ResetPasswordPage from './pages/reset-password'
import UnifiedUserProfileListView from './pages/unified-user-profile/list-view'
import UnifiedUserProfilePage from './pages/unified-user-profile'

import DestinationChangeRequests from './pages/destination-change-requests/DestinationChangeRequests'
import DestinationChangeRequest from './pages/destination-change-requests/DestinationChangeRequest'

import BatchPrebuiltAttributesSetup from './pages/audience/batch-prebuilt-attribute-setup'
import BatchPrebuiltAttributeProcesses from './pages/audience/batch-prebuilt-attribute-processes'
import BatchPrebuiltAttributeProcess from './pages/audience/batch-prebuilt-attribute-process'

import UserIdSeed from './pages/user-id-seed'
import UserIdSeeds from './pages/user-id-seeds'

import { newLog } from '_services/logs'
import SegmentConfig from './pages/segment-config'
import SourcePartners from './pages/predactiv-admin/source-partners'
import SourcePartner from './pages/predactiv-admin/source-partners/SourcePartner/SourcePartner'
import FeatureFlags from './pages/predactiv-admin/feature-flags'
import Analytics from './pages/analytics'

// load translations
const translations = require('./lib/translations.js')
i18n.load(translations)

const debounceKeyFuncMap = {}

function debouncedByKey(key, func, timeout, ...params) {
  const time = new Date().getTime()
  const exp = debounceKeyFuncMap[key]
  if (!exp || exp < time) {
    debounceKeyFuncMap[key] = time + timeout
    func(key, ...params)
  }
}

// make toast available everywhere
window.toast = (msg, duration) => debouncedByKey(msg, toast, 500, duration)
window.toast.error = (msg, duration) => debouncedByKey(msg, toast.error, 500, duration)
window.toast.success = (msg, duration) => debouncedByKey(msg, toast.success, 500, duration)

// API endpoints gets overridden in the deploy.yml file

// PROD SSO
window._sso_api = new API('https://sso.sharethis.com/v2')
// DEV SSO
// window._sso_api = new API('https://sso.sharethis.com/v2')
// LOCAL SSO
// window._sso_api = new API('https://sso.sharethis.com/v2')

window._api = new API('https://datasphere-api.sharethis.com')
window._dmp_api = new API('https://data-api.sharethis.com')

// window._api = new API('https://datasphere-api.sharethis.com')
// window._api = new API('https://datasphere-api.sharethis.com')
// window._dmp_api = new API('http://localhost:4010')

// api-dev environment
// window._api = new API('https://datasphere-api.sharethis.com')

window._api.errorInterceptor = getRefreshTokenInterceptor
window._sso_api.errorInterceptor = getRefreshTokenInterceptor
window._dmp_api.errorInterceptor = getRefreshTokenInterceptor

const SIDEBAR_CLASSES = {
  root: 'app__sidebar',
  bottom: 'app__sidebar-bottom',
}

// app
class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
    }
    this.router = React.createRef()
  }

  componentDidMount() {
    // If in old subdomain redirect to new one
    if (window.location.host.includes('studio.sharethis.com')) {
      window.location.replace(`https://datasphere.sharethis.com${window.location.pathname}`)
    }

    window._history = this.router.current.history

    // scroll page to top on page change
    this.router.current.history.listen(() => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    })

    // show app
    setTimeout(() => {
      this.setState({ visible: true })
    }, 1)

    // watch for changes in user status
    User.init()
    User.watch(this, (user) => {
      if (user) {
        window._api.token = Cookies.getCookie('token')
        window._dmp_api.token = Cookies.getCookie('dmp_token')
        window._isShareThisUser = this.isShareThisUser()
      }
    })

    if (Storage.get('attempt_login')) {
      newLog({
        entity: 'login',
        data: {
          action: 'login',
        },
      }).then(() => {
        Storage.remove('attempt_login')
      })
    }
  }

  logout() {
    User.logout()
  }

  decodeToken() {
    try {
      const token = Cookies.getCookie('token')
      const data = decode(token) //could throw InvalidTokenError
      return data
    } catch (e) {
      return null
    }
  }

  isShareThisUser() {
    const data = this.decodeToken()
    return data?.org === 'sharethis'
  }

  render() {
    let { visible } = this.state

    const login_note = 'Made with 💛 by ShareThis'
    const logo = '../static/img/datasphere@2x.png'
    const permission_text = `Ask the administrator for access if you don't have one`
    const login_title = 'POWERING HUMAN CONNECTION'

    const permissions = User?.data?.datasphere_permissions || {}

    return (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'white',
        }}
      >
        <BrowserRouter
          ref={this.router}
          getUserConfirmation={() => {
            /* Empty callback to block the default browser prompt */
          }}
        >
          <ErrorBoundary FallbackComponent={ErrorPage}>
            <NavigationProvider>
              <Route
                render={({ location }) => (
                  <div id="router" className={visible ? 'show' : 'hide'}>
                    <div
                      id="content"
                      className={classnames({
                        'no-scroll-hidden': location.pathname.includes('audience-creator/'),
                      })}
                    >
                      <ContentContainer>
                        <TransitionSwitch component={Fader} location={location}>
                          {/* User Authentication and Management */}
                          <Route
                            exact
                            path="/accept-invitation"
                            render={(props) => (
                              <AcceptInvitationPageComponent
                                {...props}
                                logo={logo}
                                name="data-studio"
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/forgot-password"
                            render={(props) => (
                              <ForgotPasswordPage
                                {...props}
                                domain={'https://datasphere.sharethis.com'}
                                logo={logo}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/login"
                            render={(props) => (
                              <Login
                                {...props}
                                logo={logo}
                                note={login_note}
                                permission_text={permission_text}
                                title={login_title}
                              />
                            )}
                          />
                          <Route exact path="/reset-password" component={ResetPasswordPage} />
                          <Route exact path="/recover-password" component={RecoverPasswordPage} />
                          <Route exact path="/settings" component={SettingsPage} />
                          {/* DataSphere Pages */}
                          <Route
                            exact
                            path="/"
                            render={() => (
                              <Choose>
                                <When condition={this.isShareThisUser()}>
                                  <Dashboard />
                                </When>
                                <Otherwise>
                                  <Redirect to="/online-media-measurements" />
                                </Otherwise>
                              </Choose>
                            )}
                          />
                          <Route exact path="/audience" component={Search} />
                          <Route
                            exact
                            path="/audience/report"
                            component={AudienceInsightsReportPage}
                          />
                          <Route exact path="/api" component={ApiPage} />
                          <Route exact path="/appnexus-audiences" component={AppNexusAudiences} />
                          <Route
                            exact
                            path="/appnexus-audiences/:id"
                            component={AppNexusAudience}
                          />
                          <Route exact path="/audience/:id" component={TaxonomyAudiencePage} />
                          <Route exact path="/audience/:id/insights" component={AudienceInsights} />
                          <Route exact path="/audience-creator" component={CustomAudiences} />
                          <Route exact path="/audience-creator/:id" component={AudienceCreator} />
                          <Route exact path="/bulk-edit-audiences" component={BulkEditAudiences} />
                          <Route
                            exact
                            path="/move-audiences-to-pdp"
                            component={MoveAudiencesToPdp}
                          />
                          <Route exact path="/lookalike-audience-seeds" component={UserIdSeeds} />
                          <Route
                            exact
                            path="/lookalike-audience-seeds/:id"
                            component={UserIdSeed}
                          />
                          <Route
                            exact
                            path="/batch-prebuilt-attributes"
                            component={BatchPrebuiltAttributeProcesses}
                          />
                          <Route
                            exact
                            path="/batch-prebuilt-attributes/setup"
                            component={BatchPrebuiltAttributesSetup}
                          />
                          <Route
                            exact
                            path="/batch-prebuilt-attributes/process/:id"
                            component={BatchPrebuiltAttributeProcess}
                          />
                          {/* <Route
                            exact
                            path="/ai-simulated-customer"
                            component={AISimulatedCustomerList}
                          />
                          <Route
                            exact
                            path="/ai-simulated-customer/:id"
                            component={AISimulatedCustomer}
                          /> */}
                          <Route exact path="/ab-custom-audiences" component={ABCustomAudiences} />
                          <Route exact path="/data-sources-apa" component={APADataSources} />
                          <Route exact path="/data-sources-apa/:id" component={DataSourceAPAPage} />
                          <Route exact path="/analytics" component={Analytics} />
                          <Route exact path="/branded-audiences" component={BrandedAudiences} />
                          <Route exact path="/changelogs" component={Changelogs} />
                          <Route exact path="/companies" component={Companies} />
                          <Route exact path="/companies/:id" component={Company} />
                          <Route exact path="/content-rule-logs" component={ContentRuleLogs} />
                          <Route exact path="/content-rules" component={ContentRules} />
                          <Route exact path="/content-rules/:id" component={ContentRule} />
                          <Route
                            exact
                            path="/content-rule-change-requests"
                            component={ContentRuleChangeRequests}
                          />
                          <Route
                            exact
                            path="/content-rule-change-requests/:id"
                            component={ContentRuleChangeRequest}
                          />
                          <Route
                            exact
                            path="/data-explorer/synthetic-users"
                            component={DataExplorerSyntheticUsers}
                          />
                          <Route exact path="/daas-clients" component={DaaSClients} />
                          <Route exact path="/daas-clients/:id" component={DaaSClients} />
                          <Route exact path="/data-feeds" component={DataFeeds} />
                          <Route exact path="/data-feeds/:id" component={DataFeed} />
                          <Route exact path="/data-explorer" component={EventFeedsList} />
                          <Route
                            exact
                            path="/unified-user-profile"
                            component={UnifiedUserProfileListView}
                          />
                          <Route
                            exact
                            path="/data-explorer/monitoring"
                            component={DataMonitoring}
                          />
                          <Route exact path="/custom-taxonomies" component={CustomTaxonomies} />
                          <Route exact path="/custom-taxonomies/:id" component={CustomTaxonomy} />
                          <Route
                            exact
                            path="/url-similarity-seeds"
                            component={UrlSimilaritySeeds}
                          />
                          <Route
                            exact
                            path="/url-similarity-seeds/:id"
                            component={UrlSimilaritySeed}
                          />
                          <Route
                            exact
                            path="/data-explorer/:id/:section?"
                            render={(props) => (
                              <EventFeedsContextProvider id={props.match.params.id}>
                                <EventFeeds {...props} />
                              </EventFeedsContextProvider>
                            )}
                          />
                          <Route
                            exact
                            path="/unified-user-profile/:id"
                            render={(props) => (
                              <EventFeedsContextProvider id={props.match.params.id}>
                                <UnifiedUserProfilePage {...props} />
                              </EventFeedsContextProvider>
                            )}
                          />
                          <Route exact path="/data-sources" component={DataSources} />
                          <Route exact path="/data-sources/:id" component={DataSource} />
                          <Route exact path="/destinations" component={Destinations} />
                          <Route exact path="/destinations/:id" component={Destination} />
                          <Route
                            exact
                            path="/destination-change-requests"
                            component={DestinationChangeRequests}
                          />
                          <Route
                            exact
                            path="/destination-change-requests/:id"
                            component={DestinationChangeRequest}
                          />
                          <Route exact path="/downloads" component={Downloads} />
                          <Route
                            exact
                            path="/pdp-audience-notification-rules"
                            component={PdpAudienceNotificationRules}
                          />
                          <Route
                            exact
                            path="/pdp-audience-notification-rules/:id"
                            component={PdpAudienceNotificationRule}
                          />
                          <Route exact path="/pdp-liveramp-report" component={PdpLiveRampReport} />
                          <Route
                            exact
                            path="/pdp-omm-billable-report"
                            component={PdpOmmBillableReport}
                          />
                          <Route exact path="/import-topics" component={ImportTopics} />
                          <Route
                            exact
                            path="/partner-branded-audiences/:id"
                            component={IndividualRecords}
                          />
                          <Route exact path="/integrations" component={Integrations} />
                          <Route exact path="/integrations/liveramp" component={LiveRamp} />
                          <Route exact path="/links" component={Links} />
                          <Route exact path="/links/:id" component={Link} />
                          <Route exact path="/log-files" component={LogFiles} />
                          <Route exact path="/log-files/:id" component={LogFile} />
                          <Route exact path="/mapping-ids" component={MappingIDs} />
                          <Route exact path="/mapping-ids/:id" component={MappingID} />
                          <Route exact path="/segment-configs" component={SegmentConfigs} />
                          <Route exact path="/segment-configs/:id" component={SegmentConfig} />
                          <Route exact path="/segment-configs/new" component={SegmentConfig} />
                          <Route
                            exact
                            path="/partner-branded-audiences"
                            component={PartnerBrandedAudiences}
                          />
                          <Route exact path="/old" component={Old} />
                          <Route exact path="/people" component={People} />
                          <Route exact path="/people/:id" component={Person} />
                          <Route exact path="/pixel-audiences" component={PixelAudiences} />
                          <Route exact path="/pixel-audiences/:id" component={PixelAudience} />
                          <Route exact path="/pixel-classes" component={PixelClasses} />
                          <Route exact path="/pixels" component={Pixels} />
                          <Route exact path="/regions" component={Regions} />
                          <Route exact path="/regions/:id" component={Region} />
                          <Route
                            exact
                            path="/salesforce-integration-partners"
                            component={SalesforceIntegrationPartners}
                          />
                          <Route
                            exact
                            path="/salesforce-integration-partners/:id"
                            component={SalesforceIntegrationPartner}
                          />
                          <Route exact path="/report/:id/insights" component={AudienceInsights} />
                          <Route exact path="/segment-ids" component={SegmentIdsPage} />
                          <Route exact path="/segment-ids/:id" component={SegmentIdPage} />
                          <Route exact path="/taxonomies" component={TaxonomiesPage} />
                          <Route exact path="/taxonomies/:id" component={Taxonomy} />
                          <Route
                            exact
                            path="/taxonomies/:slug/audiences"
                            component={TaxonomyAudiences}
                          />
                          <Route
                            exact
                            path="/taxonomies/:slug/api-integrations"
                            component={TaxonomyApiIntegrations}
                          />
                          <Route
                            exact
                            path="/taxonomies/:slug/api-integrations/:id"
                            component={TaxonomyApiIntegrationPush}
                          />
                          <Route
                            exact
                            path="/taxonomy-api-integrations"
                            component={AllTaxonomyApiIntegrations}
                          />
                          <Route
                            exact
                            path="/taxonomy-api-integrations/:id"
                            component={TaxonomyApiIntegrationPush}
                          />
                          <Route exact path="/ttd-audiences" component={TTDAudiences} />
                          <Route exact path="/ttd-audiences/:id" component={TTDAudience} />
                          <Route
                            exact
                            path="/ttd-health-audiences"
                            component={TTDHealthAudiences}
                          />
                          <Route
                            exact
                            path="/ttd-health-audiences/:id"
                            component={TTDHealthAudience}
                          />
                          <Route
                            exact
                            path="/user-attribute-syncs"
                            component={UserAttributeSyncs}
                          />
                          <Route
                            exact
                            path="/user-attribute-syncs/:id"
                            component={UserAttributeSync}
                          />
                          <Route exact path="/user-feeds" component={DataFeeds} />
                          <Route exact path="/user-feeds/:id" component={DataFeed} />
                          <Route
                            exact
                            path="/white-label-audiences"
                            component={WhiteLabelAudiences}
                          />
                          <Route
                            exact
                            path="/online-media-measurements"
                            component={MediaMeasurementCampaigns}
                          />
                          <Route
                            exact
                            path="/online-media-measurements-logs"
                            component={MediaMeasurementCampaignsLogs}
                          />
                          <Route
                            exact
                            path="/online-media-measurements/:id"
                            component={MediaMeasurementCampaign}
                          />
                          <Route exact path="/people-model" component={PeopleModel} />
                          <Route exact path="/people-model/:id" component={PeopleModel} />
                          <Route exact path="/predactiv-admin" component={PredactivAdmin} />
                          <Route exact path="/predactiv-feature-flags" component={FeatureFlags} />
                          <PDPEnvironmentProvider>
                            <Route exact path="/source-partners" component={SourcePartners} />
                            <Route exact path="/source-partners/:id" component={SourcePartner} />
                          </PDPEnvironmentProvider>

                          <Route exact path="*" component={PageNotFound} />
                          {/* DEMO SLIDES */}
                          <Route exact path="/slides" component={SlidesDemo} />
                        </TransitionSwitch>
                      </ContentContainer>
                    </div>
                    <Sidebar2
                      classes={SIDEBAR_CLASSES}
                      sections={[
                        { icon: { type: 'outline', name: 'home' }, text: 'Home', link: '/' },
                        {
                          text: 'Audience Navigator',
                          icon: { type: 'outline', name: 'contacts' },
                          groupsOrItems: [
                            {
                              text: 'Audience Insights',
                              link: '/audience',
                              icon: { type: 'outline', name: 'idea' },
                              noAuth: true,
                            },
                            {
                              text: 'Audience Creator',
                              authKey: 'Audience Creator',
                              link: '/audience-creator',
                              icon: { type: 'outline', name: 'edit' },
                            },
                            {
                              text: 'Bulk Edit Audiences',
                              authKey: 'Audience Creator',
                              link: '/bulk-edit-audiences',
                              icon: { type: 'outline', name: 'edit' },
                            },
                            ...(permissions?.predactiv?.permissions?.organization?.update
                              ? [
                                  {
                                    text: 'Move Audiences to PDP',
                                    link: '/move-audiences-to-pdp',
                                    icon: { type: 'outline', name: 'edit' },
                                    noAuth: true,
                                  },
                                ]
                              : []),
                            {
                              text: 'User ID Seeds',
                              authKey: 'Audience Creator',
                              link: '/lookalike-audience-seeds',
                              icon: { type: 'outline', name: 'edit' },
                            },
                            {
                              text: 'Batch Prebuilt Attributes',
                              authKey: 'Audience Creator',
                              link: '/batch-prebuilt-attributes',
                              icon: { type: 'outline', name: 'edit' },
                            },
                            /*{
                              text: 'AI Simulated Customer',
                              authKey: 'Audience Creator',
                              link: '/ai-simulated-customer',
                              icon: { type: 'outline', name: 'edit' },
                            },*/
                            {
                              text: 'Clone Branded Audiences',
                              authKey: 'Branded Audiences',
                              link: '/branded-audiences',
                              icon: { type: 'outline', name: 'rating-2' },
                            },
                            {
                              text: 'Taxonomies',
                              authKey: 'Audience Creator',
                              link: '/taxonomies',
                              icon: { type: 'outline', name: 'connect' },
                            },
                            {
                              text: 'Taxonomy API Integrations',
                              link: '/taxonomy-api-integrations',
                              icon: { type: 'outline', name: 'connect', size: 18 },
                              // ShareThis only: noAuth without forClients hides it from
                              // every other org, and the API refuses them too
                              noAuth: true,
                            },
                            {
                              text: 'Segment Ids',
                              authKey: 'Audience Creator',
                              link: '/segment-ids',
                              icon: { type: 'outline', name: 'services' },
                            },
                          ],
                        },
                        {
                          text: 'Integrations',
                          icon: { type: 'outline', name: 'cloudconnections', size: 18 },
                          groupsOrItems: [
                            {
                              text: 'TTD Audiences',
                              link: '/ttd-audiences',
                              icon: { type: 'outline', name: 'connect', size: 18 },
                            },
                            {
                              text: 'TTD Health Audiences',
                              link: '/ttd-health-audiences',
                              icon: { type: 'outline', name: 'connect', size: 18 },
                            },
                            {
                              text: 'Partner Branded Audiences',
                              link: '/partner-branded-audiences',
                              icon: { type: 'outline', name: 'connect', size: 18 },
                            },
                            {
                              text: 'Pixel Audiences',
                              link: '/pixel-audiences',
                              icon: { type: 'outline', name: 'connect', size: 18 },
                            },
                            {
                              text: 'AppNexus Audiences',
                              link: '/appnexus-audiences',
                              icon: { type: 'outline', name: 'connect', size: 18 },
                              noAuth: true,
                            },
                            {
                              text: 'Segment Configurations',
                              link: '/segment-configs',
                              icon: { type: 'outline', name: 'connect', size: 18 },
                              noAuth: true,
                            },
                          ],
                        },
                        {
                          text: 'Data Explorer',
                          icon: { type: 'outline', name: 'piechart', size: 18 },
                          groupsOrItems: [
                            {
                              text: 'Discovery',
                              link: '/data-explorer/discovery',
                              icon: { type: 'outline', name: 'search' },
                              noAuth: true,
                              exact: true,
                            },
                            {
                              text: 'Feed Manager',
                              icon: { type: 'outline', name: 'services' },
                              link: '/data-explorer',
                              noAuth: true,
                            },
                            {
                              text: 'Unified User Profile',
                              icon: { type: 'outline', name: 'services' },
                              link: '/unified-user-profile',
                              noAuth: true,
                            },
                            {
                              text: 'DaaS Clients',
                              link: '/daas-clients',
                              icon: { type: 'outline', name: 'society-24-px', size: 18 },
                              noAuth: true,
                            },
                            {
                              text: 'Monitoring',
                              link: '/data-explorer/monitoring',
                              noAuth: true,
                              exact: true,
                            },
                            {
                              text: 'Custom Taxonomies',
                              link: '/custom-taxonomies',
                              noAuth: true,
                            },
                          ],
                        },
                        {
                          text: 'Privacy',
                          icon: { type: 'outline', name: 'lock', size: 26 },
                          groupsOrItems: [
                            {
                              text: 'Content Rules',
                              link: '/content-rules',
                              icon: { type: 'outline', name: 'document' },
                            },
                            {
                              text: 'Content Rule Logs',
                              link: '/content-rule-logs',
                              icon: { type: 'outline', name: 'document' },
                            },
                            {
                              text: 'Content Rule Change Requests',
                              link: '/content-rule-change-requests',
                              icon: { type: 'outline', name: 'document' },
                              authKey: 'Content Rules',
                            },
                          ],
                        },
                        {
                          text: 'Company',
                          icon: { type: 'outline', name: 'briefcase', size: 26 },
                          groupsOrItems: [
                            {
                              text: 'Companies',
                              link: '/companies',
                              icon: { type: 'outline', name: 'business' },
                            },
                            {
                              text: 'Destinations',
                              link: '/destinations',
                              icon: { type: 'outline', name: 'location' },
                            },
                            {
                              text: 'Destination Change Requests',
                              link: '/destination-change-requests',
                              icon: { type: 'outline', name: 'document' },
                              authKey: 'Destinations',
                            },
                            {
                              text: 'Salesforce Integration Partners',
                              link: '/salesforce-integration-partners',
                              icon: { type: 'outline', name: 'cloudconnections', size: 18 },
                              authKey: 'Destinations',
                            },
                            {
                              text: 'Regions',
                              link: '/regions',
                              icon: { type: 'outline', name: 'verticals' },
                            },
                            {
                              text: 'Mapping IDs',
                              link: '/mapping-ids',
                              icon: { type: 'outline', name: 'contact', size: 18 },
                            },
                            {
                              text: 'Pixels',
                              link: '/pixels',
                              icon: { type: 'outline', name: 'location' },
                            },
                            {
                              text: 'Pixel Classes',
                              link: '/pixel-classes',
                              icon: { type: 'outline', name: 'location' },
                            },
                          ],
                        },
                        {
                          text: 'Resources',
                          icon: { type: 'outline', name: 'support' },
                          groupsOrItems: [
                            {
                              text: 'People',
                              link: '/people',
                              icon: { type: 'outline', name: 'maleuser' },
                            },
                            {
                              text: 'Links',
                              link: '/links',
                              icon: { type: 'outline', name: 'link', size: 20 },
                            },
                            {
                              text: 'Log Files',
                              link: '/log-files',
                              icon: { type: 'outline', name: 'folder' },
                            },
                            {
                              text: 'Data Sources',
                              link: '/data-sources',
                              icon: { type: 'outline', name: 'wifi' },
                            },
                            {
                              text: 'Downloads',
                              link: '/downloads',
                              icon: { type: 'outline', name: 'downloadcloud', size: 14 },
                              noAuth: true, // TODO: Figure out if this needs to be auth protected
                            },
                            {
                              text: 'PDP Audience Notifications',
                              link: '/pdp-audience-notification-rules',
                              icon: { type: 'outline', name: 'mail', size: 14 },
                              noAuth: true,
                            },
                            {
                              text: 'PDP LiveRamp Report',
                              link: '/pdp-liveramp-report',
                              icon: { type: 'outline', name: 'downloadcloud', size: 14 },
                              noAuth: true,
                            },
                            {
                              text: 'PDP OMM Billable Report',
                              link: '/pdp-omm-billable-report',
                              icon: { type: 'outline', name: 'downloadcloud', size: 14 },
                              noAuth: true,
                            },
                            {
                              text: 'URL Similarity Seeds',
                              link: '/url-similarity-seeds',
                              icon: { type: 'outline', name: 'connect2', size: 14 },
                              noAuth: true,
                            },
                            {
                              text: 'Changelogs',
                              link: '/changelogs',
                              icon: { type: 'outline', name: 'connect2', size: 14 },
                              noAuth: true,
                            },
                            {
                              text: 'Analytics',
                              link: '/analytics',
                              noAuth: true,
                            },
                          ],
                        },
                        {
                          text: 'Campaigns',
                          icon: { type: 'outline', name: 'speechbubble' },
                          groupsOrItems: [
                            {
                              text: 'Online Media Measurements',
                              link: '/online-media-measurements',
                              forClients: true,
                              noAuth: true,
                            },
                            {
                              text: 'Logs',
                              link: '/online-media-measurements-logs',
                              forClients: false,
                              noAuth: true,
                            },
                          ],
                        },
                        {
                          text: 'Experimental',
                          icon: { type: 'outline', name: 'femaleuser' },
                          groupsOrItems: [
                            {
                              text: 'People Model',
                              link: '/people-model',
                              noAuth: true,
                            },
                          ],
                        },
                        ...(permissions?.predactiv?.permissions
                          ? [
                              {
                                text: 'Predactiv Admin',
                                icon: { type: 'outline', name: 'services' },
                                groupsOrItems: [
                                  ...(permissions?.predactiv?.permissions?.organization?.display
                                    ? [
                                        {
                                          text: 'Predactiv Admin',
                                          link: '/predactiv-admin',
                                          noAuth: true,
                                        },
                                      ]
                                    : []),
                                  ...(permissions?.predactiv?.permissions?.features?.display
                                    ? [
                                        {
                                          text: 'Feature Flags',
                                          link: '/predactiv-feature-flags',
                                          noAuth: true,
                                        },
                                      ]
                                    : []),
                                  ...(permissions?.predactiv?.permissions?.data_sources?.display
                                    ? [
                                        {
                                          text: 'APA Data Sources',
                                          link: '/data-sources-apa',
                                          noAuth: true,
                                        },
                                      ]
                                    : []),
                                  ...(permissions?.predactiv?.permissions?.organization?.display
                                    ? [
                                        {
                                          text: 'Source Partners',
                                          link: '/source-partners',
                                          noAuth: true,
                                        },
                                      ]
                                    : []),
                                ],
                              },
                            ]
                          : []),
                      ]}
                      options={[
                        {
                          icon: { name: 'angleleft', type: 'outline' },
                          retracted: false,
                          text: 'Collapse',
                        },
                        {
                          icon: { name: 'angleright', type: 'outline' },
                          retracted: true,
                        },
                        {
                          text: 'Settings',
                          icon: { name: 'settings', type: 'outline' },
                          link: '/settings',
                          forClients: true,
                        },
                        {
                          text: 'Logout',
                          icon: { name: 'logout', type: 'outline' },
                          onClick: this.logout,
                          forClients: true,
                          noAuth: true,
                        },
                      ]}
                    />
                  </div>
                )}
              />
            </NavigationProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </div>
    )
  }
}

// export
export default App
